import type SuperJSON from "superjson";
import { Temporal } from "temporal-polyfill";

/**
 * Register the SuperJSON transformer for Temporal.PlainYearMonth.
 * Pass the SuperJSON instance you want to register on (client or server instance).
 */
export function registerPlainYearMonthTransformer(
  superjson: typeof SuperJSON
): void {
  superjson.registerCustom<Temporal.PlainYearMonth, string>(
    {
      isApplicable: (v): v is Temporal.PlainYearMonth =>
        v instanceof Temporal.PlainYearMonth,
      serialize: (d) => d.toString(),
      deserialize: (s) => Temporal.PlainYearMonth.from(s),
    },
    "Temporal.PlainYearMonth"
  );
}
